module.exports = __webpack_public_path__ + "img/neweRLogo.4efa691d.png";